import React from 'react';
import {Button} from 'semantic-ui-react';

import './index.css';

export class ChatedButton extends React.Component {
	render() {
		let tertiaryClass = '';

		if (this.props.tertiary) {
			tertiaryClass = 'tertiary';
		}

		return (
			<Button {...this.props} className={`${this.props.className} ${tertiaryClass} chatedio-button`} >{this.props.children}</Button>
		);
	}
}

export default ChatedButton;



// WEBPACK FOOTER //
// ./src/components/forms/button/index.jsx